import { z } from 'zod'

export const schemaApiCreateToken = z.object({
  response: z.object({
    Status: z.string(),
    ReferenceToken: z.string().default(''),
    AutoStartToken: z.string().default(''),
    QR: z.string().nullable().default(''),
    Signature: z.string().nullable().default(''),
    IP: z.string().nullable().default(''),
    Created: z.string().nullable().default(''),
  }),
})

export const schemaApiGetStatus = z.object({
  response: z.object({
    Status: z.string().default(''),
    AutoStartToken: z.string().nullable().default(''),
    QR: z.string().nullable().default(''),
    Name: z.string().nullable().default(''),
    OcspResponse: z.string().nullable().default(''),
    Signature: z.string().nullable().default(''),
    SSN: z.string().nullable().default(''), // Only gives SSN once the user is authenticated
    GivenName: z.string().nullable().default(''),
    Surname: z.string().nullable().default(''),
    IP: z.string().nullable().default(''), // Not currencly used but might be useful to log
  }),
})
